import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DataGrid, DataGridElement } from '../../../../lib/components/compound/dataGrid';
import { Box, Link, Tab, Tabs, Typography } from '@mui/material';
import { CalendarIcon, DocumentIcon } from '../../../../lib/icons';
import { humanFileSize } from '../../../../misc/humanFileSize';
import { DataProps, setType } from './view';
import { Button } from '../../../../lib/components/atomic/button';

interface Props extends DataProps {
  disabled?: boolean | null;
}

export const ContractView: FC<Props> = ({
  benefit,
  contractData,
  contract,
  contractSigned,
  disabled
}) => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  const selectedContractData = Array.isArray(contractData)
    ? contractData[selectedTab]
    : contractData;

  const handleClick = () => {
    if (selectedContractData) {
      window.open(
        (selectedContractData['contact_link'] || 'https://www.tpc-vorsorge.de/kontakt/').toString()
      );
    }
  };

  return (
    <Box
      sx={{
        mt: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        opacity: disabled ? 0.6 : 1.0
      }}
    >
      <Typography variant="subtitle1">{t('benefits:contract_details')}</Typography>
      {contractData && Array.isArray(contractData) && contractData.length > 1 && (
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          TabIndicatorProps={{
            style: {
              backgroundColor: '#5F7EFF'
            }
          }}
        >
          {contractData.map((record, index) => (
            <Tab
              label={record['main_partner'] || `${t('bkv:contract_document')} ${index + 1}`}
              key={index}
              style={{ color: selectedTab === index ? '#5F7EFF' : 'inherit' }}
            />
          ))}
        </Tabs>
      )}
      <DataGrid>
        {(selectedContractData &&
          benefit &&
          Object.keys(selectedContractData)
            .filter(
              (key) => typeof selectedContractData[key] !== 'object' && key !== 'contact_link'
            )
            .map((key, index) => (
              <DataGridElement
                key={index}
                title={t(`${benefit}:${key}`)}
                value={selectedContractData[key]}
                type={setType(key)}
              />
            ))) ||
          []}
      </DataGrid>
      <Box>
        {contract && (
          <Link href={contract.url} target="_blank">
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '16px',
                padding: '16px',
                boxSizing: 'border-box',
                backgroundColor: 'grey.50'
              }}
            >
              <DocumentIcon />
              <Typography>{contract.name}</Typography>
              <Typography>{humanFileSize(contract.size)}</Typography>
            </Box>
          </Link>
        )}
        {benefit === 'bkv' && !contractSigned && (
          <Button onClick={handleClick}>
            <CalendarIcon />
            {t('bkv:book_consultation')}
          </Button>
        )}
      </Box>
    </Box>
  );
};
